import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import DOMPurify from "dompurify";

/**
 * Convert HTML string → ProseMirror JSON
 * Browser-only (React)
 */
export function htmlToProseMirrorJSON(html: string) {
  if (typeof window === "undefined") {
    throw new Error("htmlToProseMirrorJSON must run in browser");
  }

  if (!html || typeof html !== "string") {
    return null;
  }

  // 🔐 Sanitize HTML first
  const safeHTML = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });

  // 🧠 Create hidden editor instance
  const editor = new Editor({
    extensions: [StarterKit],
    content: safeHTML,
  });

  const json = editor.getJSON();

  editor.destroy(); // 🧹 cleanup

  return json;
}